import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, catchError, map, retry, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { StatisticsAPI } from './api.statistics.model';

const REGIONAL_SERVICE = {
  regional: '/regional/regional',
  languages: '/regional/languages',
  country: '/country',
  region: '/region',
  city: '/cities',
  languageCurrency: '/user/language-currency'
};

export class StatisticsApi {
  private apiUrl: string = environment.API_URL;
  ADVERTISING = '/advertising/dashboard';
  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getCountryList(validCountry = false): Observable<StatisticsAPI.GetCountryListRes> {
    const params = `?validCountry=${validCountry}`;
    return this.http
      .get<StatisticsAPI.GetCountryListRes>(
        `${this.apiUrl}${REGIONAL_SERVICE.regional}${REGIONAL_SERVICE.country}${params}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map((res: any) => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getAdvertisingPerformance(startTime: number, endTime: number, region: string) {
    const endpoint = `${this.apiUrl}${this.ADVERTISING}/performance?start=${startTime}&end=${endTime}&region=${region}`;
    return this.http.get<StatisticsAPI.AdPerformanceRes>(endpoint).pipe(
      timeout(this.config.responseTimeout),
      map((res: any) => {
        return res;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getAdSummaryDetail(type: string, startTime: number, endTime: number, region: string) {
    const endpoint = `${this.apiUrl}${this.ADVERTISING}/detail/${type}?start=${startTime}&end=${endTime}&region=${region}`;
    return this.http.get<StatisticsAPI.AdSummaryDetailRes>(endpoint).pipe(
      timeout(this.config.responseTimeout),
      map((res: any) => {
        return res;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getAdSummaryTop(type: string, sort: string, startTime: number, endTime: number, region: string) {
    const endpoint = `${this.apiUrl}${this.ADVERTISING}/top/${type}/${sort}?start=${startTime}&end=${endTime}&region=${region}`;
    return this.http.get<StatisticsAPI.AdSummaryTopRes>(endpoint).pipe(
      timeout(this.config.responseTimeout),
      map((res: any) => {
        return res;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getAdAccountSummary(startTime: number, endTime: number, region: string) {
    const endpoint = `${this.apiUrl}${this.ADVERTISING}/accounts/overview?start=${startTime}&end=${endTime}&region=${region}`;
    return this.http.get<StatisticsAPI.AdsAccountSummaryRes>(endpoint).pipe(
      timeout(this.config.responseTimeout),
      map((res: any) => {
        return res;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getUserDeviceTracking(countryCode: string, startTime: string, endTime: string): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/statistics/dashboard/device-using-tracking?country_code=${countryCode}&startTime=${startTime}&endTime=${endTime}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(res => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getAdPerformance(): Observable<any[]> {
    return this.http.get<any[]>('assets/mock/list-advertising-summary.json').pipe(
      retry(1),
      map((res: any) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getListCampaign(): Observable<any[]> {
    return this.http.get<any[]>('assets/mock/list-campaign.json').pipe(
      retry(1),
      map((res: any) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getAdAccountOverview(): Observable<any[]> {
    return this.http.get<any[]>('assets/mock/list-ads-account-overview.json').pipe(
      retry(1),
      map((res: any) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }
}
